import { ShieldCheck, Heart, Compass, Users2 } from "lucide-react";

const VALUES = [
  { icon: Heart, title: "Person‑centred", desc: "Your goals lead. Our team listens, adapts and delivers care that respects your story." },
  { icon: ShieldCheck, title: "Trusted & registered", desc: "Fully NDIS registered, with police‑checked and continuously trained support workers." },
  { icon: Compass, title: "Clear navigation", desc: "We make the NDIS easier — from plan reviews to provider connections, you’re never alone." },
  { icon: Users2, title: "Inclusive by design", desc: "Culturally safe support for First Nations, CALD and LGBTQIA+ participants." },
];

export default function About() {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 md:py-28 bg-brand-sand/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16 grid lg:grid-cols-2 gap-12 lg:gap-20 items-center">
        <div className="relative">
          <div className="rounded-[2rem] overflow-hidden ring-1 ring-brand-sand shadow-lg">
            <img
              data-testid="about-image"
              src="https://images.pexels.com/photos/7551664/pexels-photo-7551664.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=900"
              alt="Support worker walking with a participant"
              className="w-full h-[480px] object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div>
          <span className="text-xs uppercase tracking-[0.22em] text-brand-terracotta font-semibold">About us</span>
          <h2 className="mt-3 font-heading font-semibold tracking-tight text-brand-forest text-3xl sm:text-4xl lg:text-5xl">
            We don’t deliver services. <br className="hidden md:block" />
            We build <span className="italic font-medium">relationships</span>.
          </h2>
          <p className="mt-5 text-base lg:text-lg text-brand-muted leading-relaxed">
            Founded by carers for carers, Guiding Support Services exists because we
            believe great support starts with great listening. Whether you’re new to the
            NDIS or moving from another provider — our team meets you where you are.
          </p>

          <div className="mt-10 grid sm:grid-cols-2 gap-5">
            {VALUES.map((v) => {
              const Icon = v.icon;
              return (
                <div
                  key={v.title}
                  data-testid={`about-value-${v.title.toLowerCase().replace(/\s+/g, "-").replace(/[^a-z0-9-]/g, "")}`}
                  className="bg-white rounded-2xl border border-brand-sand p-5"
                >
                  <div className="h-10 w-10 rounded-xl bg-brand-forest/10 text-brand-forest grid place-items-center">
                    <Icon className="h-5 w-5" />
                  </div>
                  <h3 className="mt-4 font-heading font-semibold text-brand-ink">{v.title}</h3>
                  <p className="mt-1.5 text-sm text-brand-muted leading-relaxed">{v.desc}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}
